import type { CardInput, IProvider } from '../types';

const ZOOP_API = 'https://api.zoop.ws';

/**
 * Tokenização no navegador (`POST /v1/marketplaces/{id}/cards/tokens`), a única
 * rota da Zoop sem mTLS. Autentica com a ZSK de tokenização (Basic, senha
 * vazia) — chave com perfil só para isso, feita para ir ao cliente. O token
 * vale 1 h e uma única vez; o backend o associa ao comprador antes de cobrar.
 */
export class ZoopProvider implements IProvider {
  constructor(
    private readonly marketplaceId: string,
    private readonly tokenizationKey: string,
    private readonly gatewayConfigId: string,
  ) {}

  async generate(card: CardInput): Promise<string> {
    const [month, year] = card.expiration.split('/');

    const response = await fetch(`${ZOOP_API}/v1/marketplaces/${this.marketplaceId}/cards/tokens`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(`${this.tokenizationKey}:`)}`,
      },
      body: JSON.stringify({
        holder_name: card.holder,
        expiration_month: month.padStart(2, '0'),
        expiration_year: year.length === 2 ? `20${year}` : year,
        card_number: card.number.replace(/\s/g, ''),
        security_code: card.cvv,
      }),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Zoop tokenize failed: ${error}`);
    }

    const data = (await response.json()) as { id: string };
    return data.id;
  }
}
